Object.defineProperty(exports,"__esModule",{value:true});var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _partialRight2=require("lodash/partialRight");var _partialRight3=_interopRequireDefault(_partialRight2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);

var _victoryCore=require("victory-core");









var _helperMethods=require("./helper-methods");var _helperMethods2=_interopRequireDefault(_helperMethods);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var fallbackProps={
endAngle:360,
height:400,
innerRadius:0,
cornerRadius:0,
padAngle:0,
padding:30,
width:400,
startAngle:0,
colorScale:[
"#ffffff",
"#f0f0f0",
"#d9d9d9",
"#bdbdbd",
"#969696",
"#737373",
"#525252",
"#252525",
"#000000"]};var



VictoryPie=function(_React$Component){_inherits(VictoryPie,_React$Component);function VictoryPie(){_classCallCheck(this,VictoryPie);return _possibleConstructorReturn(this,(VictoryPie.__proto__||Object.getPrototypeOf(VictoryPie)).apply(this,arguments));}_createClass(VictoryPie,[{key:"renderData",value:function renderData(










































































































props){var
dataComponent=props.dataComponent,labelComponent=props.labelComponent,groupComponent=props.groupComponent;
var dataComponents=[];
var labelComponents=[];
for(var index=0,len=this.dataKeys.length;index<len;index++){
var dataProps=this.getComponentProps(dataComponent,"data",index);
dataComponents[index]=_react2.default.cloneElement(dataComponent,dataProps);

var labelProps=this.getComponentProps(labelComponent,"labels",index);
if(labelProps&&labelProps.text!==undefined&&labelProps.text!==null){
labelComponents[index]=_react2.default.cloneElement(
labelComponent,(0,_assign3.default)({},labelProps,{renderInPortal:false}));

}
}
return labelComponents.length>0?
_react2.default.cloneElement.apply(_react2.default,[groupComponent,{}].concat(dataComponents,labelComponents)):
dataComponents;
}},{key:"renderContainer",value:function renderContainer(

props,group){var
containerComponent=props.containerComponent;
var parentProps=this.getComponentProps(containerComponent,"parent","parent");
return _react2.default.cloneElement(containerComponent,parentProps,group);
}},{key:"renderGroup",value:function renderGroup(

children,style,offset){var
x=offset.x,y=offset.y;
return _react2.default.cloneElement(
this.props.groupComponent,
{role:"presentation",style:style,transform:"translate("+x+", "+y+")"},
children);

}},{key:"shouldAnimate",value:function shouldAnimate()

{
return Boolean(this.props.animate);
}},{key:"render",value:function render()

{
var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,"pie");var

animate=props.animate,standalone=props.standalone,width=props.width,height=props.height;



if(this.shouldAnimate()){
var whitelist=[
"data","endAngle","height","innerRadius","cornerRadius","padAngle","padding",
"colorScale","startAngle","style","width"];

return(
_react2.default.createElement(_victoryCore.VictoryTransition,{animate:animate,animationWhitelist:whitelist},
_react2.default.createElement(this.constructor,props)));


}

var calculatedProps=_helperMethods2.default.getCalculatedValues(props,fallbackProps);var
style=calculatedProps.style,padding=calculatedProps.padding,radius=calculatedProps.radius;
var offsetWidth=width/2+padding.left-padding.right;
var offsetHeight=height/2+padding.top-padding.bottom;
var offset={
x:offsetWidth+radius>width?radius+padding.left-padding.right:offsetWidth,
y:offsetHeight+radius>height?radius+padding.top-padding.bottom:offsetHeight};

var children=this.renderData(props);
var group=this.renderGroup(children,style.parent,offset);
return standalone?this.renderContainer(props,group):group;
}}]);return VictoryPie;}(_react2.default.Component);VictoryPie.displayName="VictoryPie";VictoryPie.defaultTransitions={onExit:{duration:500,before:function before(){return{y:0,label:" "};}},onEnter:{duration:500,before:function before(){return{y:0,label:" "};},after:function after(datum){return{y:datum.y,label:datum.label};}}};VictoryPie.propTypes={animate:_react.PropTypes.object,colorScale:_react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string),_react.PropTypes.oneOf(["grayscale","qualitative","heatmap","warm","cool","red","green","blue"])]),containerComponent:_react.PropTypes.element,cornerRadius:_victoryCore.PropTypes.nonNegative,data:_react.PropTypes.array,dataComponent:_react.PropTypes.element,endAngle:_react.PropTypes.number,events:_react.PropTypes.arrayOf(_react.PropTypes.shape({target:_react.PropTypes.oneOf(["data","labels","parent"]),eventKey:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string]),eventHandlers:_react.PropTypes.object})),eventKey:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string]),groupComponent:_react.PropTypes.element,height:_victoryCore.PropTypes.nonNegative,innerRadius:_victoryCore.PropTypes.nonNegative,labelComponent:_react.PropTypes.element,labelRadius:_react.PropTypes.oneOfType([_victoryCore.PropTypes.nonNegative,_react.PropTypes.func]),labels:_react.PropTypes.oneOfType([_react.PropTypes.func,_react.PropTypes.array]),name:_react.PropTypes.string,padAngle:_victoryCore.PropTypes.nonNegative,padding:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.shape({top:_react.PropTypes.number,bottom:_react.PropTypes.number,left:_react.PropTypes.number,right:_react.PropTypes.number})]),sharedEvents:_react.PropTypes.shape({events:_react.PropTypes.array,getEventState:_react.PropTypes.func}),standalone:_react.PropTypes.bool,startAngle:_react.PropTypes.number,style:_react.PropTypes.shape({parent:_react.PropTypes.object,data:_react.PropTypes.object,labels:_react.PropTypes.object}),theme:_react.PropTypes.object,width:_victoryCore.PropTypes.nonNegative,x:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string,_react.PropTypes.arrayOf(_react.PropTypes.string)]),y:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string,_react.PropTypes.arrayOf(_react.PropTypes.string)])};VictoryPie.defaultProps={data:[{x:"A",y:1},{x:"B",y:2},{x:"C",y:3},{x:"D",y:1},{x:"E",y:2}],standalone:true,x:"x",y:"y",dataComponent:_react2.default.createElement(_victoryCore.Slice,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",null),theme:_victoryCore.VictoryTheme.grayscale};VictoryPie.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryPie.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=


(0,_victoryCore.addEvents)(VictoryPie);


//////////////////
// WEBPACK FOOTER
// ./~/victory-pie/lib/components/victory-pie.js
// module id = 1289
// module chunks = 0 1